import OptimizationHeader from './OptimizationHeader';

export default OptimizationHeader;
